<!-- Shared pieces --------------------------------------------------------- -->
<ng-template #avatarTpl let-size="size">
  <span class="am-avatar" [class.am-avatar--lg]="size === 'lg'" aria-hidden="true">
    @if (showImage()) {
      <img [src]="state().avatarUrl" alt="" (error)="onAvatarError()" decoding="async">
    } @else if (state().initials) {
      <span class="am-avatar__initials">{{ state().initials }}</span>
    } @else {
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
        <path d="M12 12a4 4 0 100-8 4 4 0 000 8zM4.5 20a7.5 7.5 0 0115 0"/>
      </svg>
    }
  </span>
</ng-template>

<ng-template #badgeTpl>
  @switch (state().membership) {
    @case ('vip') {
      <span class="am-badge am-badge--vip">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 8l4.5 4 4-6 4 6 4.5-4-2 10.5h-13L3.5 8z" fill="currentColor"/></svg>
        VIP
      </span>
    }
    @case ('regular') {
      <span class="am-badge am-badge--regular">{{ 'sale4you.account.badge.regular' | translate }}</span>
    }
    @default {
      @if (state().loading) {
        <span class="am-badge am-badge--loading" aria-hidden="true"></span>
      }
    }
  }
</ng-template>

<ng-template #greetingTpl>
  <span class="am-greeting">
    {{ greetingKey() | translate }}@if (state().firstName) {<span>, {{ state().firstName }}</span>}
    @if (greetingEmoji()) {<span class="am-greeting__emoji" aria-hidden="true">{{ greetingEmoji() }}</span>}
  </span>
</ng-template>

<!-- Mobile drawer card ---------------------------------------------------- -->
@if (variant === 'summary') {
  <a class="am-summary" [routerLink]="['/personal/user-info']" (click)="onItemClick()">
    <ng-container *ngTemplateOutlet="avatarTpl; context: { size: 'lg' }"></ng-container>
    <span class="am-summary__text">
      <ng-container *ngTemplateOutlet="greetingTpl"></ng-container>
      <span class="am-summary__meta">
        <ng-container *ngTemplateOutlet="badgeTpl"></ng-container>
        @if (state().email) {
          <span class="am-email" dir="ltr">{{ state().email }}</span>
        }
      </span>
    </span>
  </a>
} @else {

<!-- Header trigger + dropdown --------------------------------------------- -->
<div class="am-root">
  <button #trigger type="button" class="am-trigger"
    aria-haspopup="menu"
    [attr.aria-expanded]="open()"
    [attr.aria-controls]="menuId"
    [attr.aria-label]="('sale4you.account.menu.label' | translate) + (state().firstName ? ' – ' + state().firstName : '')"
    (click)="toggle()"
    (keydown)="onTriggerKeydown($event)">
    <span class="am-trigger__text">
      <ng-container *ngTemplateOutlet="greetingTpl"></ng-container>
      <ng-container *ngTemplateOutlet="badgeTpl"></ng-container>
    </span>
    <ng-container *ngTemplateOutlet="avatarTpl; context: { size: 'md' }"></ng-container>
    <svg class="am-chevron" [class.am-chevron--open]="open()" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M6 9l6 6 6-6"/>
    </svg>
  </button>

  @if (open()) {
    <div class="am-menu" [id]="menuId" role="menu"
      [attr.aria-label]="'sale4you.account.menu.label' | translate"
      (keydown)="onMenuKeydown($event)">
      <div class="am-menu__head">
        <ng-container *ngTemplateOutlet="avatarTpl; context: { size: 'lg' }"></ng-container>
        <div class="am-menu__who">
          @if (displayName()) {
            <span class="am-menu__name">{{ displayName() }}</span>
          }
          <ng-container *ngTemplateOutlet="badgeTpl"></ng-container>
          @if (state().email && state().email !== displayName()) {
            <span class="am-email" dir="ltr">{{ state().email }}</span>
          }
        </div>
      </div>

      <div class="am-menu__list" role="none">
        @for (entry of menu; track entry.link) {
          <a #item class="am-item" role="menuitem" tabindex="-1"
            [routerLink]="[entry.link]" routerLinkActive="am-item--active"
            (click)="onItemClick()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path [attr.d]="entry.icon"/>
            </svg>
            <span>{{ entry.key | translate }}</span>
          </a>
        }
        <div class="am-sep" role="separator"></div>
        <button #item type="button" class="am-item am-item--danger" role="menuitem" tabindex="-1"
          (click)="onLogout()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M15 4h3a2 2 0 012 2v12a2 2 0 01-2 2h-3M10 17l-5-5 5-5M5 12h11"/>
          </svg>
          <span>{{ 'sale4you.account.menu.logout' | translate }}</span>
        </button>
      </div>
    </div>
  }
</div>
}
